/** Largest numeric message id in the list (0 when empty): the cursor for incremental polls. */
export function maxMessageId(messages) {
  return (messages || []).reduce((max, m) => {
    const id = Number(m && m.id);
    return Number.isFinite(id) && id > max ? id : max;
  }, 0);
}

/** Appends messages not already present (by id), keeping existing order; new ones are added in id order. */
export function mergeChatMessages(existing, incoming) {
  const known = new Set((existing || []).map((m) => m.id));
  const added = (incoming || []).filter((m) => m && !known.has(m.id));
  if (added.length === 0) return existing || [];
  added.sort((a, b) => Number(a.id) - Number(b.id));
  return [...(existing || []), ...added];
}
